<div class="date-picker-label">{{ label }}</div>
<div class="date-picker-field-wrapper">
  <div class="field-wrapper date-picker-field">
    <label>
      <input
        appDisableMouseWheel
        type="number"
        pattern="[0-9]*"
        inputmode="numeric"
        maxlength="2"
        min="1"
        max="31"
        placeholder="DD"
        [value]="day"
        (blur)="onTouched()"
        (input)="handleInputChange($event, 2, 'day')"
        class="date-field"
        [class.submit-error]="isError"
      />
      <span>Day</span>
    </label>
  </div>
  <div class="field-wrapper date-picker-field">
    <label>
      <input
        appDisableMouseWheel
        type="number"
        pattern="[0-9]*"
        inputmode="numeric"
        maxlength="2"
        min="1"
        max="12"
        placeholder="MM"
        [value]="month"
        (blur)="onTouched()"
        (input)="handleInputChange($event, 2, 'month')"
        class="month-field"
        [class.submit-error]="isError"
      />
      <span>Month</span>
    </label>
  </div>
  <div class="field-wrapper date-picker-field">
    <label>
      <input
        appDisableMouseWheel
        type="number"
        pattern="[0-9]*"
        inputmode="numeric"
        maxlength="4"
        min="1900"
        placeholder="YYYY"
        [value]="year"
        (blur)="onTouched()"
        (input)="handleInputChange($event, 4, 'year')"
        class="year-field"
        [class.submit-error]="isError"
      />
      <span>Year</span>
    </label>
  </div>
</div>
